// The job queue in the browser. An action the zone lock or another job keeps
// from starting is refused with "queueable"; the API client then asks here and
// sends it again with ?queue=1, so every action can go to the queue. The
// question comes from QueuePrompt. A confirmation that already said so
// (confirmJob) approves it, so that nobody is asked twice.
export type QueueQuestion = { reason: string; answer: (yes: boolean) => void }

let listener: ((q: QueueQuestion) => void) | null = null

export function onQueueQuestion(l: (q: QueueQuestion) => void) {
  listener = l
  return () => {
    listener = null
  }
}

export function askQueue(reason: string): Promise<boolean> {
  return new Promise((resolve) => {
    if (listener) listener({ reason, answer: resolve })
    else resolve(false)
  })
}

let approvedUntil = 0

export function approveQueue() {
  approvedUntil = Date.now() + 30000
}

// queueApproved answers once: the approval is for the action just confirmed
export function queueApproved() {
  const ok = Date.now() < approvedUntil
  approvedUntil = 0
  return ok
}
